import {
  deleteDataFromServerWithFullResponse,
  throwIfDeleteFailed,
  getDataFromServer,
  postDataToServer,
  putDataToServer
} from '../../../util';

export class RiskIndicatorModule {
  constructor(baseURL, httpHeaders) {
    this.baseURL = baseURL;
    this.httpHeaders = httpHeaders;
  }

  getRiskIndicators = async (payload) => {
    const { category } = payload;

    const response = await getDataFromServer(
      `${this.baseURL}/riskIndicators/${category}/rules`,
      this.httpHeaders
    );

    if (response instanceof Error) throw response;
    return response;
  };

  putRiskIndicatorThreshold = async (payload) => {
    const response = await postDataToServer(
      `${this.baseURL}/riskIndicators/addRules`,
      payload
    );

    if (response instanceof Error) throw response;
    return response;
  };

  // FIN-12858 — `response instanceof Error` only catches a NETWORK failure. The axios
  // instance runs with `validateStatus: false`, so an HTTP 4xx/5xx resolves normally and
  // `deleteDataFromServer` hands back the body, never an Error — a rejected delete looked
  // like a successful one. Check the status instead.
  deleteRiskIndicatorThreshold = async (payload) => {
    const { uuid } = payload;

    return throwIfDeleteFailed(
      await deleteDataFromServerWithFullResponse(
        `${this.baseURL}/riskIndicators/delete/${uuid}`
      ),
      'Failed to delete risk indicator threshold'
    );
  };

  updateRiskIndicatorThreshold = async (payload) => {
    const { riskIndicators } = payload;

    const data = {
      riskIndicators
    };

    const response = await putDataToServer(
      `${this.baseURL}/riskIndicators/update`,
      this.httpHeaders,
      {},
      data
    );

    // if (response instanceof Error) throw response;
    if (response.status !== 200) throw response;
    return response;
  };

  postRiskIndicatorTrigger = async (payload) => {
    const response = await postDataToServer(
      `${this.baseURL}/riskIndicators/triggerTraining`,
      {}
    );

    if (response instanceof Error) throw response;

    return response;
  };

  getRiskIndicatorThresholds = async (payload) => {
    const { category, limit, offset, searchText } = payload;

    const params = {
      limit,
      offset
    };

    if (searchText) {
      params.riskIndicator = searchText;
    }

    const response = await getDataFromServer(
      `${this.baseURL}/riskIndicators/${category}/fetchRules`,
      this.httpHeaders,
      params
    );

    if (response instanceof Error) throw response;
    return response;
  };

  getRiskIndicatorStaticProperties = async (payload) => {
    const response = await getDataFromServer(
      `${this.baseURL}/riskHistory/staticProperties`,
      this.httpHeaders
    );

    if (response instanceof Error) throw response;
    return response;
  };
}
